import { z } from 'zod';
import { listingValues, switchParameter } from './shared.js';

export default {
  label: 'Y-Ybar Diagram', group: 'system',
  description: 'Y-Ybar diagram: chief-ray height against marginal-ray height at each surface, for paraxial and real rays.',
  settingsSchema: z.strictObject({
    paraxial: z.enum(listingValues).default('Yes').describe('Plot the native HCY/HMY arrays. Installed YYBAR default: Yes.'),
    real: z.enum(listingValues).default('No').describe('Plot the native real-ray arrays: chief R1 at the last field, marginal R2 at field 1. Installed YYBAR default: No.'),
  }),
  parameters: [switchParameter('paraxial', 'Paraxial rays'), switchParameter('real', 'Real rays')],
  coverage: 'Covers surface 1 through the image, in lens units. There is no wavelength selection. If CODE V reports a ray error, no result is shown. Lenses with more than 50 surfaces are not supported.',
} as const;
